__turbopack_context__.v({
  "editLink": "CreatorBanner-module-scss-module__l8nhMW__editLink",
});
